module.exports = __webpack_public_path__ + "img/reserve_menu01_img_01_on.f249792a.png";